import ProfileHeader from './ProfileHeader'

export default ProfileHeader
